import api from './client';
import type { ApiResponse, SupportTicketResponse } from '../../types/api';

export const getSupportTickets = async (): Promise<SupportTicketResponse> => {
  return api.get<any, SupportTicketResponse>('/api/admin/support-tickets');
};

export const updateSupportTicket = async (ticketId: string, status: string): Promise<ApiResponse> => {
  return api.put<any, ApiResponse>(`/api/admin/support-tickets/${ticketId}`, { status });
};

export const createSupportTicket = async (data: {
  subject: string;
  message: string;
  priority?: string;
}): Promise<ApiResponse> => {
  return api.post<any, ApiResponse>('/api/support/tickets', data);
};